// extracted by mini-css-extract-plugin
var _1 = "active-media-preview";
var _2 = "base-link";
var _3 = "#000000";
var _4 = "#76F366";
var _5 = "#EB8632";
var _6 = "#ECC834";
var _7 = "#21FC87";
var _8 = "#EA4A30";
var _9 = "#C7EA45";
var _a = "#272B2B";
var _b = "#BDBDBD";
var _c = "#7D7D7D";
var _d = "#6A0DAD";
var _e = "#3A65FF";
var _f = "#4A90E2";
var _10 = "#ffffff";
var _11 = "reset-button";
var _12 = "1200px";
var _13 = "992px";
var _14 = "1366px";
var _15 = "768px";
var _16 = "1475px";
var _17 = "576px";
var _18 = "1600px";
var _19 = "320px";
var _1a = "2500px";
var _1b = "single-page-responsive-font-size";
var _1c = "textFieldCloseButtonWrapper";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "colorBlack", _4 as "colorGradeEX", _5 as "colorGradeFR", _6 as "colorGradeGD", _7 as "colorGradeOU", _8 as "colorGradePR", _9 as "colorGradeVG", _a as "colorNeutral", _b as "colorNeutralLighest", _c as "colorNeutralLight", _d as "colorNonOwnerSweetLine", _e as "colorOwnerSweetLine", _f as "colorRegularLinks", _10 as "colorWhite", _11 as "reset-button", _12 as "screenlg", _13 as "screenmd", _14 as "screenml", _15 as "screensm", _16 as "screenxlg", _17 as "screenxs", _18 as "screenxxlg", _19 as "screenxxs", _1a as "screenxxxlg", _1b as "single-page-responsive-font-size", _1c as "textFieldCloseButtonWrapper" }
export default { "active-media-preview": _1, "base-link": _2, "colorBlack": _3, "colorGradeEX": _4, "colorGradeFR": _5, "colorGradeGD": _6, "colorGradeOU": _7, "colorGradePR": _8, "colorGradeVG": _9, "colorNeutral": _a, "colorNeutralLighest": _b, "colorNeutralLight": _c, "colorNonOwnerSweetLine": _d, "colorOwnerSweetLine": _e, "colorRegularLinks": _f, "colorWhite": _10, "reset-button": _11, "screenlg": _12, "screenmd": _13, "screenml": _14, "screensm": _15, "screenxlg": _16, "screenxs": _17, "screenxxlg": _18, "screenxxs": _19, "screenxxxlg": _1a, "single-page-responsive-font-size": _1b, "textFieldCloseButtonWrapper": _1c }
